export default __webpack_public_path__ + "static/media/background.0b86f9e5.png";